// extracted by mini-css-extract-plugin
export default {"addShoppingListForm":"ShoppingListForm_addShoppingListForm__EW4YY","label":"ShoppingListForm_label__ds7hs","previewTab":"ShoppingListForm_previewTab__OpmMr"};